<template>
  <footer class="app-footer text-white">
    <div class="w footer-main flex justify-between">
      <div class="footer-brand">
        <div class="flex align-center margin-bottom-25 text-bold footer-shine">东软天枢院 </div>
        <p class="text-white text-14 text-content margin-bottom-16 footer-desc footer-shine">
          © 2024 Modern Architect. High-End Engineering Excellence.
        </p>
        <div class="social-icons flex margin-top-33">
          <img src="@/assets/icon25.png" alt="" class="w-20 h-21">
          <img src="@/assets/icon24.png" alt="" class="w-22 h-21 margin-lr-16">
          <div class="text-14 footer-shine footer-shine--click" @click="handleno">备案号： 京ICP备2021005748号-4</div>
        </div>
      </div>
      <div v-for="col in linkColumns" :key="col.title" class="footer-col">
        <h4 class="text-white text-bold text-16 margin-bottom-20 footer-shine">{{ col.title }}</h4>
        <template v-for="item in col.links">
          <router-link v-if="!item.onClick" :key="'link-' + item.name" :to="item.to"
            class="footer-link text-white text-14 footer-shine">{{ item.name }}</router-link>
          <a v-else :key="'action-' + item.name" href="javascript:;" class="footer-link text-white text-14 footer-shine"
            @click="item.onClick">{{ item.name }}</a>
        </template>
      </div>

      <!-- 公共配置：关注 / 联系 -->
      <div class="footer-contact">
        <h4 class="text-white text-bold text-16 margin-bottom-20 footer-shine">关注我们</h4>
        <div class="footer-qr-list flex">
          <div v-if="config.official_account_one" class="footer-qr-item">
            <img :src="config.official_account_one" class="footer-qr-img" :alt="config.official_account_one_name">
            <div class="footer-qr-name text-12 footer-shine">{{ config.official_account_one_name }}</div>
          </div>
          <div v-if="config.official_account_two" class="footer-qr-item">
            <img :src="config.official_account_two" class="footer-qr-img" :alt="config.official_account_two_name">
            <div class="footer-qr-name text-12 footer-shine">{{ config.official_account_two_name }}</div>
          </div>
          <div v-if="config.qrcode" class="footer-qr-item">
            <img :src="config.qrcode" class="footer-qr-img" alt="客服">
            <div class="footer-qr-name text-12 footer-shine">{{ config.kefu_name }}</div>
          </div>
        </div>
        <a v-if="config.phone" :href="`tel:${config.phone}`"
          class="footer-phone text-14 flex align-center footer-shine">
          <i class="el-icon-phone-outline margin-right-6" />
          {{ config.phone }}
        </a>
      </div>
    </div>

    <!-- 工程师申请状态弹窗 -->
    <el-dialog :visible.sync="applyEngineerVisible" width="500px" custom-class="publish-success-dialog"
      :show-close="false" append-to-body center>
      <div class="success-modal flex flex-direction align-center">
        <img :src="applyEngineerDialogIcon" class="success-icon" alt="">
        <p class="success-text text-20 margin-tb-24">{{ applyEngineerDialogText }}</p>
        <button v-if="user.engineer_status === 'rejected'" type="button" class="resubmit-btn text-16 margin-top-32"
          @click="handleResubmit">
          重新提交
        </button>
      </div>
    </el-dialog>
  </footer>
</template>

<script>
import eventBus from '@/utils/eventBus'
import { getConfig } from '@/api/index'
import { fetchUserInfo, fetchUserStats } from '@/api/user'

export default {
  name: 'AppFooter',
  data() {
    return {
      socialIcons: ['el-icon-chat-dot-round', 'el-icon-message', 'el-icon-share'],
      user: {
        engineer_status: ''
      },
      applyEngineerVisible: false,
      config: {
        official_account_one: '',
        official_account_one_name: '',
        official_account_two: '',
        official_account_two_name: '',
        qrcode: '',
        phone: '',
        kefu_name: ''
      },
      linkColumns: [
        {
          // title: '首页',
          links: [
            { name: '首页', to: '/' },
            // { name: '认证工程师', onClick: this.handleApplyEngineer },
            { name: '技术服务', to: '/service' },
            { name: '服务案例', to: '/cases' },
          ]
        },
        {
          title: '',
          links: [
            { name: '技术工程师', to: '/engineer' },
            { name: '课程服务', to: '/course' },
            { name: '配套资源', to: '/resource' },
          ]
        },
        {
          // title: '关于我们',
          links: [
            { name: '天枢院简介', to: '/about' },
            { name: '联系我们', to: '/contact' },
            { name: '公司官网', onClick: this.handleOfficialSite }
          ]
        },
        // {
        //   title: '政策',
        //   links: [
        //     { name: '隐私政策', to: '/user/settings/1' },
        //     { name: '用户协议', to: '/user/settings/0' }
        //   ]
        // }
      ]
    }
  },
  computed: {
    canGoApplyEngineer() {
      const status = this.user.engineer_status
      return !status || status === 'none' || status === 'draft'
    },
    applyEngineerDialogIcon() {
      const status = this.user.engineer_status
      if (status === 'pending' || status === 'draft') {
        return require('@/assets/icon11.png')
      }
      if (status === 'rejected' || status === 'closed') {
        return require('@/assets/icon10.png')
      }
      return require('@/assets/icon9.png')
    },
    applyEngineerDialogText() {
      const status = this.user.engineer_status
      if (status === 'pending' || status === 'draft') {
        return '审核中'
      }
      if (status === 'rejected') {
        return '审核未通过'
      }
      if (status === 'closed') {
        return '已下架'
      }
      return '提交审核成功'
    }
  },
  created() {
    this.fetchConfig()
  },
  methods: {
    fetchConfig() {
      getConfig()
        .then((res) => {
          const data = res.data || {}
          this.config.official_account_one = data.official_account_one || ''
          this.config.official_account_one_name = data.official_account_one_name || ''
          this.config.official_account_two = data.official_account_two || ''
          this.config.official_account_two_name = data.official_account_two_name || ''
          this.config.qrcode = data.qrcode || ''
          this.config.phone = data.phone || '',
            this.config.kefu_name = data.kefu_name || ''
        })
        .catch(() => { })
    },
    handleno() {
      window.open('https://beian.miit.gov.cn/')
    },
    handleOfficialSite() {
      window.open('https://www.imatsoft.com', '_blank')
    },
    handleApplyEngineer() {
      if (sessionStorage.getItem('isLoggedIn') !== '1' || !sessionStorage.getItem('token')) {
        eventBus.$emit('auth:unauthorized')
        return
      }
      Promise.all([fetchUserInfo(), fetchUserStats()])
        .then(([infoRes, statsRes]) => {
          const data = { ...(infoRes.data || {}), ...(statsRes.data || {}) }
          Object.assign(this.user, data)
          if (this.canGoApplyEngineer) {
            this.$router.push('/profile-setup')
          } else {
            this.applyEngineerVisible = true
          }
        })
    },
    handleResubmit() {
      this.applyEngineerVisible = false
      this.$router.push({ path: '/profile-setup', query: { resubmit: '1' } })
    }
  }
}
</script>

<style lang="scss" scoped>
.app-footer {
  max-height: 440px;
  background-image: url('@/assets/icon12.png');
  background-size: 100% 100%;
  padding-top: 60px;
}

.footer-main {
  margin-top: 0;
  margin-bottom: 0;
  padding-bottom: 40px;
  flex-wrap: wrap;
  gap: 24px;
}

.footer-brand {
  max-width: 300px;
}

.logo-icon {
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
}

.footer-desc {
  opacity: 0.85;
  line-height: 1.8;
  color: rgba(255, 255, 255, 0.7);
}

.footer-col {
  min-width: 120px;

  .footer-link {
    display: block;
    text-decoration: none;
    margin-bottom: 16px;
    opacity: 0.6;
    transition: opacity 0.2s;

    &:hover {
      opacity: 1;
    }
  }
}

/* 文字悬停流光：文字始终可见 */
.footer-shine {
  position: relative;
  overflow: hidden;
  cursor: default;
  color: #fff;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: -50%;
    width: 40%;
    height: 100%;
    background: linear-gradient(100deg,
        transparent 0%,
        rgba(255, 255, 255, 0.15) 35%,
        rgba(255, 255, 255, 0.65) 50%,
        rgba(255, 255, 255, 0.15) 65%,
        transparent 100%);
    transform: skewX(-18deg);
    opacity: 0;
    pointer-events: none;
  }

  &:hover::after {
    opacity: 1;
    animation: footer-text-shine 0.9s ease;
  }

  &--click {
    cursor: pointer;
  }
}

.footer-link.footer-shine {
  color: #fff;

  &:hover {
    opacity: 1;
  }
}

.footer-desc.footer-shine,
.footer-qr-name.footer-shine {
  color: rgba(255, 255, 255, 0.75);
}

.footer-phone.footer-shine {
  color: rgba(255, 255, 255, 0.85);

  i {
    color: inherit;
  }
}

@keyframes footer-text-shine {
  0% {
    left: -50%;
  }

  100% {
    left: 120%;
  }
}

@media (prefers-reduced-motion: reduce) {
  .footer-shine:hover::after {
    animation: none;
    opacity: 0;
  }
}

.footer-contact {
  flex-shrink: 0;
}

.footer-qr-list {
  gap: 16px;
}

.footer-qr-item {
  text-align: center;
}

.footer-qr-img {
  width: 72px;
  height: 72px;
  object-fit: cover;
  display: block;
  border-radius: 6px;
  background: #fff;
  padding: 4px;
  box-sizing: border-box;
}

.footer-qr-name {
  margin-top: 8px;
  opacity: 0.75;
  color: #fff;
  white-space: nowrap;
}

.footer-phone {
  margin-top: 16px;
  color: #fff;
  text-decoration: none;
  opacity: 0.85;
  transition: opacity 0.2s;

  &:hover {
    opacity: 1;
  }
}

.social-icon {
  width: 36px;
  height: 36px;
  background: rgba(255, 255, 255, 0.15);
  margin-right: 12px;
  cursor: pointer;
  transition: background 0.2s;

  &:hover {
    background: rgba(255, 255, 255, 0.3);
  }

  &.social-icon-sm {
    width: 28px;
    height: 28px;
    margin-right: 0;
  }
}

.footer-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.15);
  padding: 20px 0;


  .w {
    margin-top: 0;
    margin-bottom: 0;
  }
}

/* 工程师申请状态弹窗 */
::v-deep .publish-success-dialog {
  border-radius: 12px;
}

.success-modal {
  padding: 16px 0 8px;
}

.success-icon {
  width: 80px;
  height: 80px;
  object-fit: contain;
}

.success-text {
  color: #111827;
}

.resubmit-btn {
  min-width: 120px;
  height: 40px;
  padding: 0 24px;
  color: #fff;
  background: #009d42;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 500;
  transition: background 0.2s;

  &:hover {
    background: #008a3a;
  }
}
</style>
